module.exports = __webpack_public_path__ + "img/1.b435916c.jpg";